var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, object, bool, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import ResultTermCardAPI from './result-term-service-api';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Button, Checkbox } from '@philips-internal/oswald-ui-components/lib/components';
import './result-term-service.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ButtonType, Size } from '@philips-internal/oswald-ui-constants';
let ResultTermService = class ResultTermService extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            check: false
        };
        this.getTermo = () => {
            const { data } = this.props;
            return data && data.termDescription;
        };
        this.submitTermUse = () => {
            const { onSubmitTermUse } = this.props;
            if (isFunction(onSubmitTermUse)) {
                onSubmitTermUse(new ClickEvent({
                    value: {
                        onSubmitTermUse
                    }
                }));
            }
        };
    }
    onCheck() {
        this.setState({ check: !this.state.check });
    }
    render() {
        const { showCheck, enabled } = this.props;
        return (React.createElement("div", { className: "c-term-service" },
            React.createElement("div", { className: "c-result-term-service", dangerouslySetInnerHTML: { __html: this.getTermo() } }),
            showCheck &&
                (React.createElement("div", { className: "c-term-service__check" },
                    React.createElement("div", { className: "c-term-service__check-checkbox" },
                        React.createElement(Checkbox, { uuid: '4583ac01-00e0-4e10-bfc1-7d84aee1fa8e', name: '', label: `${MessageService.translate('newaccount.text.agree.with')} ${MessageService.translate(this.props.alias)}`, onChange: () => this.onCheck(), value: this.state.check, enabled: enabled })),
                    React.createElement("div", { className: "c-term-service__check-button" },
                        React.createElement(Button, { size: Size.LARGE, value: MessageService.translate('results.confirm'), type: ButtonType.SUBMIT, enabled: this.state.check, onClick: () => this.submitTermUse() }))))));
    }
};
ResultTermService.DefaultProps = {
    showCheck: false
};
ResultTermService.propTypes = {
    alias: string,
    data: object,
    enabled: bool,
    onSubmitTermUse: eventListener,
    showCheck: bool
};
ResultTermService = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ResultTermCardAPI })
], ResultTermService);
export default ResultTermService;
//# sourceMappingURL=result-term-service.js.map